import { MijnRoute } from '../../mijn-navigatie.model';

export const PAYMENT_BATCHES_UPLOAD: MijnRoute = {
    path: 'upload',
    navigationEvent: 'toBetaalbatchesUpload',
    regex: /^\/betaalbatches\/upload$/,
    webcomponent: 'mijn-betalen-betaalbatches-webcomponent',
    internalPath: '/upload'
};
